// extracted by mini-css-extract-plugin
export var col = "footer-module--col--b33c9";
export var footer = "footer-module--footer--06c9d";
export var links = "footer-module--links--5221b";
export var row = "footer-module--row--bfaf6";
export var socials = "footer-module--socials--bfd25";